import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const footerBgImage = 'https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=75,format=auto/assets/0b4cb68f-6aab-477c-8129-a4a720b56096/118428733-696760547579131-6862768956582941410-n.jpg';

  return (
    <footer className="relative bg-neutral-950 border-t border-neutral-900 text-neutral-400 pt-16 pb-8 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <img
          src={footerBgImage}
          alt=""
          className="w-full h-full object-cover object-center opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-neutral-950/75 via-neutral-950/85 to-neutral-950" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Company Info */}
        <div className="flex flex-col gap-4">
          <Link to="/" className="flex items-center group">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=320,quality=90,format=auto/assets/0b4cb68f-6aab-477c-8129-a4a720b56096/logo.jpg"
              alt="Danry Diamant Boring ApS Logo"
              className="h-16 w-auto object-contain rounded brightness-95"
            />
          </Link>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col gap-4">
          <h3 className="text-white font-bold text-sm uppercase tracking-wider">Hurtig navigation</h3>
          <nav className="flex flex-col gap-2.5 text-sm font-medium tracking-wide">
            <Link to="/" className="hover:text-brand-orange transition-colors">Forside</Link>
            <Link to="/diamantboring" className="hover:text-brand-orange transition-colors">Diamantboring</Link>
            <Link to="/om-os" className="hover:text-brand-orange transition-colors">Om</Link>
            <Link to="/galleri" className="hover:text-brand-orange transition-colors">Galleri</Link>
            <Link to="/kontakt" className="hover:text-brand-orange transition-colors">Kontakt</Link>
          </nav>
        </div>

        {/* Services */}
        <div className="flex flex-col gap-4">
          <h3 className="text-white font-bold text-sm uppercase tracking-wider">Vores ydelser</h3>
          <nav className="flex flex-col gap-2.5 text-sm">
            <Link to="/diamantboring" className="hover:text-brand-orange transition-colors">Diamantboring i beton</Link>
            <Link to="/diamantboring" className="hover:text-brand-orange transition-colors">Ventilationsboringer</Link>
            <Link to="/diamantboring" className="hover:text-brand-orange transition-colors">Boring til installationer</Link>
            <Link to="/diamantboring" className="hover:text-brand-orange transition-colors">Specialboringer</Link>
          </nav>
        </div>

        {/* Contact Info */}
        <div className="flex flex-col gap-4">
          <h3 className="text-white font-bold text-sm uppercase tracking-wider">Kontakt os</h3>
          <div className="flex flex-col gap-3 text-sm">
            <div className="flex items-start gap-3">
              <i className="fa-solid fa-location-dot text-brand-orange mt-1 w-4 text-center" />
              <span>
                Amager Landevej 54 1. tv.<br />
                2770 Kastrup
              </span>
            </div>
            <div className="flex items-center gap-3">
              <i className="fa-solid fa-phone text-brand-orange w-4 text-center" />
              <a href="tel:+4522971411" className="hover:text-brand-orange transition-colors whitespace-nowrap">
                22 97 14 11
              </a>
            </div>
            <div className="flex items-center gap-3">
              <i className="fa-solid fa-envelope text-brand-orange w-4 text-center" />
              <a href="mailto:danrydiamant@gmail.com" className="hover:text-brand-orange transition-colors whitespace-nowrap">
                danrydiamant@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-neutral-900 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-neutral-500">
        <div>
          &copy; {currentYear} Danry Diamant Boring ApS. CVR-nr: 46118685. Alle rettigheder forbeholdes.
        </div>
        <div className="flex items-center gap-6">
          <span>Udviklet med præcision</span>
          <span>·</span>
          <a href="tel:+4522971411" className="text-brand-orange hover:underline whitespace-nowrap">
            Ring 22 97 14 11
          </a>
        </div>
      </div>
    </footer>
  );
}
